import { Component, OnInit } from '@angular/core';
import { LayoutService } from '../layout.service';
import { environment } from '../../../environments/default/environment';
import { CommonModule } from '@angular/common';
import { PurpleFitTabMenuComponent } from '../purple-fit-tab-menu/purple-fit-tab-menu.component';
import { PRPVUserFull, ApiPurpleFitRegisterRequest, ApiPurpleFitCompleteRegistrationRequest, ApiPurpleFitUpdateUserInfoRequest } from '../../../core-modules/sdk';
import { PurpleSimpleButtonComponent } from '@purple-lib/purple-ui-widgets';
import { PurpleUserService } from '@purple-lib/purple-users-core';
import { PurpleEditableTextDirective } from '@purple-lib/purple-edit-translations';

@Component({
    selector: 'purple-fit-footer',
    templateUrl: './purple-fit-footer.component.html',
    styleUrls: ['./purple-fit-footer.component.scss'],
    imports: [CommonModule, PurpleFitTabMenuComponent, PurpleSimpleButtonComponent, PurpleEditableTextDirective]
})
export class PurpleFitFooterComponent implements OnInit {

  showTabMenu: boolean = environment.SHOW_TAB_MENU_MOBILE;

  constructor(public layoutSvc: LayoutService, public userSvc: PurpleUserService<PRPVUserFull, ApiPurpleFitRegisterRequest, ApiPurpleFitCompleteRegistrationRequest, ApiPurpleFitUpdateUserInfoRequest>) { }

  ngOnInit() {}

}
